module.exports = __webpack_public_path__ + "img/3.b648e9fd.jpg";